export enum ModalSize {
    Small = 'sm',
    Large = 'lg',
}
export interface ModalProps {
    children: React.ReactNode | React.ReactNode[];
    show?: boolean;
    onChange?: Function;
    size?: ModalSize;
}